/**
 * Attempt API calls
 */

import apiClient from './client.js';
import { AttemptWithResponses, CreateResponseInput, AttemptResults } from '../../types/models';

export interface StartAttemptResponse {
  attempt_id: string;
  assessment: any;
  questions: any[];
}

export interface RespondResponse {
  response_id: string;
  question_id: string;
  status: string;
  current_question_index: number;
  percent_complete: number;
}

export type GetAttemptByIdResponse = AttemptWithResponses & {
  assessment: any
  questions: any[]
  time_elapsed_seconds: number
  percent_complete?: number
  current_question_index?: number
  category_scores?: any[]
}

export const attemptsApi = {
  /**
   * List attempts with optional filters
   */
  list: async (params?: {
    assessment_id?: string;
    user_id?: string;
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<{ data: any[]; pagination: any }> => {
    const response = await apiClient.get('/attempts', { params });
    return response.data;
  },

  /**
   * Start a new attempt
   */
  start: async (assessmentId: string, data?: Record<string, any>): Promise<StartAttemptResponse> => {
    const response = await apiClient.post(`/assessments/${assessmentId}/start`, data || {});
    return response.data;
  },

  /**
   * Get attempt by ID
   */
  getById: async (id: string): Promise<GetAttemptByIdResponse> => {
    const response = await apiClient.get(`/attempts/${id}`);
    return response.data;
  },

  /**
   * Submit response to a question
   */
  respond: async (attemptId: string, data: CreateResponseInput): Promise<RespondResponse> => {
    const response = await apiClient.post(`/attempts/${attemptId}/respond`, data);
    return response.data;
  },

  /**
   * Complete an attempt
   */
  complete: async (attemptId: string): Promise<AttemptResults> => {
    const response = await apiClient.post(`/attempts/${attemptId}/complete`);
    return response.data;
  },

  /**
   * Soft delete an attempt
   */
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/attempts/${id}`);
  },
};
